<div class="flex flex-col">

  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Reporting Country*</mat-label>
      <mat-select (selectionChange)="isShowOkButton();onReportingCountrySelectionChange($event)"
                  [(ngModel)]="data.input.reportingCountryCode">
        <mat-option *ngFor="let country of reportingCountries" [value]="country.code">
          {{country?.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="acceptedFileExtensions && acceptedFileExtensions.length"
       class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>File Type?*</mat-label>
      <mat-select (selectionChange)="isShowOkButton();onFileTypeSelectionChange($event)"
                  [(ngModel)]="data.input.fileType">
        <mat-option *ngFor="let acceptedFileExtension of acceptedFileExtensions" [value]="acceptedFileExtension">
          {{acceptedFileExtension}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="selectedCountryCode === 'FR' && data.input.fileType === 'XML'"
       class="flex flex-row justify-start items-start auto-flex">
    <mat-checkbox disabled [(ngModel)]="data.input.allowEncryption" (change)="handleCheckbox($event)">Allow Encryption.
      (Encryption is mandatory for France authority)
    </mat-checkbox>
  </div>

  <div *ngIf="selectedCountryCode" class="file-selector-fieldset-container flex-1-0-auto " (drop)="onDrop($event)"
       (dragover)="onDragOver($event)">
    <fieldset class="file-selector-fieldset flex-1-0-100">
      <legend> {{legend}}{{required ? '*' : '' }}</legend>
      <div class="file-uploader">

        <label class="uploader-label">Drag a file here or...</label>

        <input hidden type="file" (change)="onFileSelect($event);isShowOkButton();" #fileInput/>
        <button mat-button
                class="mat-raised-button browse-btn"
                (click)="fileInput.click()"
                class="browse-btn"
                aria-label="add file"
                particleAnalytics
                analyticsCategory="file-selector"
                analyticsAction="add-file-btn">
          <span class="mat-button-wrapper">
            <i class="fa-solid fa-arrow-up-to-line"></i>
            Browse for file
          </span>
        </button>

        <div class="file-name-container flex flex-row justify-start items-center">
          <div id="upload-file-dialog-textarea" [matTooltip]="fileName" contenteditable="true"></div>
          <div *ngIf="file">
            <span>{{fileExtension}} ({{file.size / 1024 | number:'0.0-1'}}KB)</span>
            <button mat-icon-button class="upload-file-remover-btn"
                    (click)="removeFile();isShowOkButton();"
                    aria-label="remove file">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="m-t-5 m-b-10 mat-error">
    {{fileError}}
  </div>
  <div *ngIf="selectedCountryCode" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Reporting Entity</mat-label>
      <input matInput placeholder="Reporting Name" [(ngModel)]="data.input.reportingEntityName"
             (input)="isShowOkButton()"
             particleAnalytics
             analyticsCategory=""
             analyticsAction="" required>
    </mat-form-field>
  </div>
  <div *ngIf="selectedCountryCode" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Reporting Frequency*</mat-label>
      <mat-select (selectionChange)="isShowOkButton()" [(ngModel)]="data.input.reportingFrequency">
        <mat-option *ngFor="let filetype of filingTypes" [value]="filetype.filingType">
          {{filetype?.header}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="selectedCountryCode=='DE'" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>BZSt Number</mat-label>
      <input matInput placeholder="BZSt Number" (change)="isShowOkButton()" [(ngModel)]="data.input.bZStNumber"
             [readonly]="true"
             particleAnalytics
             analyticsCategory=""
             analyticsAction="" required>
    </mat-form-field>
  </div>
  <div *ngIf="selectedCountryCode=='DE'" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Account ID</mat-label>
      <input matInput placeholder="Account ID" type="number" (change)="isShowOkButton()"
             [(ngModel)]="data.input.accountID" [readonly]="true"
             particleAnalytics
             analyticsCategory=""
             analyticsAction="" required>
    </mat-form-field>
  </div>
  <div *ngIf="selectedCountryCode=='FR'" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Identification Number</mat-label>
      <input matInput placeholder="Identification Number" (input)="isShowOkButton()"
             [(ngModel)]="data.input.identificationNumber"
             particleAnalytics
             analyticsCategory=""
             analyticsAction="" required>
    </mat-form-field>
  </div>

  <div *ngIf="notes" class="notification-message-container w-p-100 m-0">
    <div>
      <p><strong>Note:</strong> {{notes}}</p>
    </div>
  </div>
</div>
